module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-list"
  }, [(!_vm.orders.length) ? _c('div', {
    staticClass: "order-404"
  }, [_vm._v("\n    暂时没有订单！\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order._id,
      staticClass: "order-item",
      on: {
        "click": function($event) {
          return _vm.goToDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "order-no"
    }, [_c('span', {
      staticClass: "order-name"
    }, [_vm._v("订单编号：" + _vm._s(order._id))]), _vm._v(" "), _c('span', {
      staticClass: "order-status"
    }, [_vm._v(_vm._s(_vm._f("calStatus")(order.status)))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-item"
    }, [_c('ul', _vm._l((order.products), function(g, index) {
      return _c('li', {
        key: g._id + index
      }, [_c('p', {
        staticClass: "cart-item"
      }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_vm._v("¥" + _vm._s(Math.round(100 * g.quantity * g.price) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
        staticStyle: {
          "float": "right"
        }
      }, [_vm._v("(" + _vm._s(g.quantity / (Number((g.unit2 && g.priceTransfer || 1)))) + _vm._s(g.unit2 || '份') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "quantity"
      }, [_vm._v("    " + _vm._s(g.quantity) + _vm._s(g.unit || '斤'))]), _vm._v(" "), (g.suppliers && g.suppliers[0] && g.suppliers[0] !== order.supplier._id) ? _c('span', {
        staticStyle: {
          "float": "right",
          "color": "red"
        }
      }, [_vm._v(_vm._s(_vm.supplierMap[g.suppliers[0]]))]) : _vm._e()])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "total-price"
    }, [_c('span', {
      staticClass: "created_time"
    }, [_vm._v(_vm._s(_vm._f("filterTime")(order.createTime)))]), _vm._v(" "), _c('span', [_vm._v("总计：¥" + _vm._s(order.roughPrice) + " | " + _vm._s(_vm.STATUS_MAP[order.status]))])]), _vm._v(" "), _c('div', {
      staticClass: "order-info"
    }, [_c('span', [_vm._v("备注：" + _vm._s(order.notes))])]), _vm._v(" "), _c('div', {
      staticClass: "order-info"
    }, [_c('span', {
      staticClass: "customer"
    }, [_vm._v("客户：" + _vm._s(order.customer.name))]), _vm._v(" "), _c('span', {
      staticClass: "supplier"
    }, [_vm._v("供应商：" + _vm._s(order.supplier && order.supplier.name))])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-46e36404"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/DeliveryOrders.vue
// module id = 539
// module chunks = 1